import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reissueRunnerToken } from "./api";
import type { RunnerTokenResponse } from "./api";
import { isRunnerNotFound } from "./errors";

// Перевыпуск токена раннера. Список раннеров сам по себе не меняется
// (токен в нём не отображается), но инвалидируем `runners` вместе с
// `queue` — тот же набор, что и регистрация, ради единообразия и на
// случай, если read-модель когда-нибудь станет зависеть от состояния
// токена. Новый токен в query cache не кладём — только вызывающему
// компоненту; в `data` этой мутации (TanStack Query `MutationCache`) он
// живёт до `reset()` — вызывающий (`RunnersSection`) зовёт его по
// закрытию модалки показа токена.
export function useReissueRunnerToken(): ReturnType<
  typeof useMutation<RunnerTokenResponse, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<RunnerTokenResponse, Error, string>({
    mutationFn: (runnerId) => reissueRunnerToken(runnerId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["runners"] });
      void queryClient.invalidateQueries({ queryKey: ["queue"] });
    },
    // Раннера нет (снят) — список обновляем, как при снятии.
    onError: (err) => {
      if (isRunnerNotFound(err)) {
        void queryClient.invalidateQueries({ queryKey: ["runners"] });
      }
    },
  });
}
